import React from 'react';
import PropTypes from 'prop-types';
import { Box, List, ListItemText } from '@mui/material';
import { NavHashLink } from 'react-router-hash-link'; 

import { StyledNavItem, StyledNavItemIcon } from './styles';
import Iconify from '../iconify';

SimpleNavSection.propTypes = {
  allowedNavConfigs: PropTypes.array,
};

export default function SimpleNavSection({ allowedNavConfigs = [], ...other }) {
  //   const [selectedPath, setSelectedPath] = useState();

  //   console.log(selectedPath);

  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {allowedNavConfigs.map((item, index) => (
          <NavItem
            // onClick={() => setSelectedPath(item.title)}
            // sx={{
            //   color: selectedPath === item.title ? 'text.primary' : 'inherit',
            //   bgcolor: selectedPath === item.title ? 'action.selected' : 'inherit',
            //   fontWeight: selectedPath === item.title ? 'fontWeightBold' : 'inherit',
            // }}
            key={item.title}
            item={item}
            index={index}
          />
        ))}
      </List>
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem component={NavHashLink} to={path} smooth>
      {icon && (
        <StyledNavItemIcon>
          <Iconify icon={icon} />
        </StyledNavItemIcon>
      )}
      <ListItemText disableTypography primary={title} />
      {info && info}
    </StyledNavItem>
  );
}
